// extracted by mini-css-extract-plugin
export var callout = "plp_group-module--callout--7cccb";
export var callouts = "plp_group-module--callouts--c028e";
export var copy = "plp_group-module--copy--718de";
export var ingroup = "plp_group-module--ingroup--e7289";
export var mobile_all = "plp_group-module--mobile_all--5f6a6";
export var tile_group = "plp_group-module--tile_group--1b270";
export var tile_group_img = "plp_group-module--tile_group_img--e7df7";
export var tile_more = "plp_group-module--tile_more--03353";
export var title = "plp_group-module--title--7873d";